import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../../../../ui';
import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { getFormattedPrice } from '../../../../../shared/i18n/price/utils/getFormattedPrice';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { getDaysInTotalDetails } from '../../../../domain/utils/getDaysInTotalDetails';
import themed from '../../../../../../ui/themer/themed';

export const StyledBookingSummarySection = styled.div<
	{ hasBorder?: boolean },
	ITheme
>`
	border-bottom: ${({ hasBorder = true }) =>
		hasBorder ? themed(({ border }) => border.default) : '0'};
	padding: 16px 0;
`;

export const StyledBookingSummarySectionHeader = styled.div`
	display: flex;
	justify-content: space-between;

	h4 {
		margin-bottom: 0;
		font-size: 20px;
		color: #000;
	}
`;

interface IBookingSummarySectionProps {
	title: string;
	daysInTotal?: number;
	price?: IPrice;
	children?: ReactNode;
	hasBorder?: boolean;
}

export const BookingSummarySection = ({
	title,
	price,
	daysInTotal,
	children,
	hasBorder = true,
}: IBookingSummarySectionProps) => {
	const { t } = useTranslation();

	return (
		<StyledBookingSummarySection hasBorder={hasBorder}>
			<StyledBookingSummarySectionHeader>
				<div>
					<h4>{title}</h4>
					{daysInTotal && <h4>{getDaysInTotalDetails(daysInTotal, t)}</h4>}
				</div>
				<div>{price ? getFormattedPrice(price) : ''}</div>
			</StyledBookingSummarySectionHeader>

			{children}
		</StyledBookingSummarySection>
	);
};
